import { render, staticRenderFns } from "./editarFicha.vue?vue&type=template&id=17cb67fc&"
import script from "./editarFicha.vue?vue&type=script&lang=js&"
export * from "./editarFicha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports